import React from 'react';
import { Col, Row } from '@/lib/utils';
import { MediumText, RegularText } from '@/lib/Text';
import SvgIcon from '@/components/SvgIcon';

/**
 * 정산 숫자를 불러오지 못했을 때 표·합계 자리를 대신하는 오류 상태.
 * 0원·빈 표로 보이면 정상 금액으로 읽히므로, 숫자 대신 이 안내만 보인다(월·강사 이동은 위에 그대로 남는다).
 */
const SettlementLoadError = ({ message, onRetry }: { message: string; onRetry?: () => void }) => (
    <Col
        role="alert"
        className="w-full items-center py-[56px] px-[24px] rounded-[16px] bg-[#FFFBEB] border border-solid border-[#FDE68A] mb-[40px]"
    >
        <SvgIcon name="SvgWarningInCircle" size={28} fill="#B45309" className="mb-[12px]" />
        <MediumText fontSize={18} lineHeight={26} color="#92400E" className="mb-[6px] text-center break-keep">
            정산 금액을 불러오지 못했어요
        </MediumText>
        <RegularText fontSize={15} lineHeight={22} color="#92400E" className="text-center break-keep">
            {message}
        </RegularText>
        {onRetry && (
            <Row
                role="button"
                tabIndex={0}
                className="mt-[18px] items-center justify-center h-[40px] px-[18px] rounded-[9px] bg-white border border-solid border-[#FDE68A] cursor-pointer"
                onClick={onRetry}
                onKeyDown={(e) => e.key === 'Enter' && onRetry()}
            >
                <RegularText fontSize={15} lineHeight={22} color="#92400E">
                    다시 시도
                </RegularText>
            </Row>
        )}
    </Col>
);

export default SettlementLoadError;
